import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { paths } from '@app/constants';
import { useHydration } from '@app/utils';
import { Role } from '@data/sdk/match';
import { useAppUserStore, useOptimisticSignUpStore } from '@data/storage';
import { useHasAccess } from './hooks';

export const PrivateRoute = ({ allowedRoles = [] }: { allowedRoles: Role[] }) => {
  const location = useLocation();
  const hasHydrated = useHydration();
  const hasAccess = useHasAccess(allowedRoles);

  const { user } = useAppUserStore();
  const { isLoading } = useOptimisticSignUpStore();

  // Redirect to sign in if user is not logged and patient sign up is not loading
  if (hasHydrated && !user && !isLoading)
    return <Navigate to={`/${paths.sign_in}`} state={{ from: location }} />;

  if (!hasAccess) return null;

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <Outlet />
    </QueryParamProvider>
  );
};
